import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';

import { NotificationContainerComponent } from './containers/notification-container/notification-container.component';
import { FaqContainerComponent } from './containers/faq-container/faq-container.component';
import { ContentThreeTopTasksContainerComponent } from './containers/content-three-top-tasks-container/content-three-top-tasks-container.component';
import { ContentFourTopTasksContainerComponent } from './containers/content-four-top-tasks-container/content-four-top-tasks-container.component';
import { HeroContainerComponent } from '../hero-container/hero-container.component';

@NgModule({
  imports: [
    provideLazyLoad({
      FaqSection: FaqContainerComponent,
      ThreeTopTasksSection: ContentThreeTopTasksContainerComponent,
      FourTopTasksSection: ContentFourTopTasksContainerComponent,
      Hero: HeroContainerComponent,
      HeroMinimal: HeroContainerComponent,
      HeroWithAppButtons: HeroContainerComponent,
      HeroWithAsset: HeroContainerComponent,
      HeroWithWidget: HeroContainerComponent,
      NotificationSection: NotificationContainerComponent,

      // TechDebt: Here for backwards compatibility, will be removed before closing ATL-2468
      InformationBar: NotificationContainerComponent,
    }),
  ],
})
export class ContentLazyModule {}
